import SoundOnIcon from "@/common/images/icons/soundOnIcon.svg?react";
import SoundOffIcon from "@/common/images/icons/soundOffIcon.svg?react";
import "./SoundButton.scss";

interface ISoundButtonProps {
  enabled: boolean;
  onClick: () => void;
}

export const SoundButton: React.FC<ISoundButtonProps> = ({ enabled, onClick }) => {
  return (
    <button className="SoundButton" onClick={onClick} aria-label={`Sound ${enabled ? "On" : "Off"}`}>
      {enabled ? (
        <SoundOnIcon />
      ) : (
        <SoundOffIcon />
      )}

      <div className="label">{enabled ? "On" : "Off"}</div>
    </button>
  );
};
